import { AppUpload, type IAppUpload, type IUploadStores } from "./AppUpload";
import { type IUploadStore, UploadStore } from "./UploadStore";
import type { IUploadIndexViewModel } from "./network/contracts/IUploadIndexViewModel";
import { type IUploadCodeAndSourceSelectionStore, UploadCodeAndSourceSelectionStore } from "./content/upload-code-and-source-selection/UploadCodeAndSourceSelectionStore";
import { CodeAndSourceValidationFetcher } from "../network/fetchers/CodeAndSourceValidationFetcher";
import { Fetcher } from "../util/io/Fetcher";
import { type IPatientUploadCompleteCallbackStore, PatientUploadCompleteCallbackStore } from "./PatientUploadCompleteCallbackStore";
import type { IAppStores } from "../shared-components/AppMaster";
import { DicomUploadTusFingerprintStore } from "./DicomUploadTusFingerprintStore";
import { CurrentUploadSettingsStore } from "./CurrentUploadSettingsStore";

export interface IAppUploadFactory {
    createMaster(uploadViewModel: IUploadIndexViewModel, appStores: IAppStores): Promise<IAppUpload>;
}

export class AppUploadFactory implements IAppUploadFactory {
    public async createMaster(uploadViewModel: IUploadIndexViewModel, appStores: IAppStores): Promise<IAppUpload> {
        
        /* fetchers */
        const fetcher = new Fetcher(); //-PJ- Jasper: add fetcher monitor?

        /* stores */
        const currentUploadSettingsStore = new CurrentUploadSettingsStore(uploadViewModel);
        const uploadCodeAndSourceSelectionStore: IUploadCodeAndSourceSelectionStore = new UploadCodeAndSourceSelectionStore(
            new CodeAndSourceValidationFetcher(fetcher),
            currentUploadSettingsStore,
        );

        const patientUploadCompleteCallbackStore: IPatientUploadCompleteCallbackStore = new PatientUploadCompleteCallbackStore(fetcher);
        const dicomUploadTusFingerprintStore = new DicomUploadTusFingerprintStore();

        const uploadStore: IUploadStore = new UploadStore(
            uploadCodeAndSourceSelectionStore,
            patientUploadCompleteCallbackStore,
            dicomUploadTusFingerprintStore,
        );

        const UploadStores: IUploadStores = {
            ...appStores,
            uploadStore,
            uploadCodeAndSourceSelectionStore,
            dicomUploadTusFingerprintStore,
            currentUploadSettingsStore,
        };

        return new AppUpload(UploadStores);
    }
}
